import React from 'react';
import axios from 'axios';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const baseURL = window.location.hostname.includes('localhost') || 
  window.location.hostname.includes('127.0.0.1') 
  ? 'http://backend.localhost' 
  : 'https://api.antiquewhiteart.com';

const handleFAQClick = async (faq_item) => {
  console.log('FAQ item clicked');
  try {
      await axios.post(`${baseURL}/files/track`, { action_type: 'FAQ_click', file_name: faq_item },  { headers: { 'Content-Type': 'application/json' } });
  } catch (error) {
      console.error('Error tracking bestseller click:', error);
  }
};

const FAQ = () => {

  return (
    <Box sx={{ width: '100%', maxWidth: 800, margin: '0 auto', mt: 4, mb: 4 }}>
      <Typography variant="h4" gutterBottom textAlign="center">
        Frequently Asked Questions
      </Typography>
      <Accordion >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          onClick={() => handleFAQClick('Where do I find my downloads?')}
        >
          <Typography variant="h6">Where do I find my downloads?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="subtitle1" gutterBottom><strong>iPhone (iOS):</strong></Typography>
          <Typography paragraph>
            1. Open the "Files" app on your iPhone.<br />
            2. Tap on "Browse" at the bottom right of the screen.<br />
            3. Under "Locations," tap "On My iPhone" or "iCloud Drive" depending on where you saved the file.<br />
            4. Navigate to the "Downloads" folder to find your file.
          </Typography>

          <Typography variant="subtitle1" gutterBottom><strong>Android:</strong></Typography>
          <Typography paragraph>
            1. Open the "Files" or "My Files" app on your Android device.<br />
            2. Tap on "Downloads" under the "Categories" section.<br />
            3. Your downloaded files should be listed there.
          </Typography>

          <Typography variant="subtitle1" gutterBottom><strong>Windows:</strong></Typography>
          <Typography paragraph>
            1. Open "File Explorer" on your Windows computer.<br />
            2. Click on "Downloads" from the Quick Access menu on the left.<br />
            3. Your downloaded files should be in this folder.
          </Typography>

          <Typography variant="subtitle1" gutterBottom><strong>Mac:</strong></Typography>
          <Typography paragraph>
            1. Open the "Finder" app on your Mac.<br />
            2. In the left sidebar, click on "Downloads." <br />
            3. You should find your downloaded files in this folder.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3a-content"
          id="panel3a-header"
          onClick={() => handleFAQClick('Can I get a custom size?')}
        >
          <Typography variant="h6">Can I get a custom size?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Sure! If your custom size is up to 24x36 inches, please contact us via Etsy messages at awatart.etsy.com. Custom size files are provided at no additional cost.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4a-content"
          id="panel4a-header"
          onClick={() => handleFAQClick('Where can I print my digital art?')}
        >
          <Typography variant="h6">Where can I print my digital art?</Typography>
        </AccordionSummary>
        <AccordionDetails>

          <Typography variant="subtitle1" gutterBottom><strong>Let me print it for you</strong></Typography>
            <Typography paragraph>
                You can print out any wall art at my store <b><a href="https://www.etsy.com/listing/1892000460">here</a></b>. I use high-quality 230gsm paper with matte finish and ship out your prints on the next business day.

                Please don't hesitate to contact me via <a href="mailto:contact@antiquewhite.art?subject=Printing">contact@antiquewhite.art</a> or Etsy messages should you have any questions.
            </Typography>

            <Typography variant="subtitle1" gutterBottom><strong>Online printing services</strong></Typography>
            <Typography paragraph>
                Many online printing services offer high-quality printing of digital art, such as Shutterfly, Snapfish, or Printful.
            </Typography>

            <Typography variant="subtitle1" gutterBottom><strong>Local print shops</strong></Typography>
            <Typography paragraph>
                You can also take your digital art file to a local print shop, such as FedEx Office or Staples, for printing.
            </Typography>

            <Typography variant="subtitle1" gutterBottom><strong>At home</strong></Typography>
            <Typography paragraph>
                If you have a good quality printer at home, you can also print your digital art on your own. Just make sure you have the right type of paper and ink to get the best results.
            </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel5a-content"
          id="panel5a-header"
          onClick={() => handleFAQClick('What is the best paper for printing?')}
        >
          <Typography variant="h6">What is the best paper for printing?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            For printing vintage digital prints, we recommend using a heavy weight (175gsm or more), matte, or lightly textured fine art paper for a classic and timeless look.

            Some recommended fine art papers are: Hahnemühle FineArt Baryta, Epson Exhibition Fiber, Moab Entrada Rag Natural.

            Note: We also recommend to test the paper with your printer and perform a color calibration for the best possible print quality.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default FAQ;
